import { useMemo, useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

export default function HistoricoSaidas({ historico }) {
  const [abertos, setAbertos] = useState({});

  const grupos = useMemo(() => {
    const mapa = new Map();

    historico.forEach((movimento) => {
      const chave = movimento.produtoId || movimento.id;
      if (!mapa.has(chave)) mapa.set(chave, []);
      mapa.get(chave).push(movimento);
    });

    return [...mapa.entries()];
  }, [historico]);

  if (!grupos.length) {
    return (
      <div className="p-6 text-center text-gray-500">
        Nenhuma saída registrada.
      </div>
    );
  }

  return (
    <div className="divide-y">
      {grupos.map(([chave, movimentacoes]) => {
        const aberto = !!abertos[chave];
        const primeiro = movimentacoes[0];
        const total = movimentacoes.reduce(
          (soma, movimento) => soma + Number(movimento.quantidade || 0),
          0,
        );

        return (
          <div key={chave}>
            <button
              type="button"
              onClick={() =>
                setAbertos((atual) => ({ ...atual, [chave]: !aberto }))
              }
              className="flex w-full items-center gap-3 p-3 text-left hover:bg-gray-50"
            >
              {aberto ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
              <div className="min-w-0 flex-1">
                <div className="truncate font-medium">
                  {primeiro.produtoDescricao || "Produto"}
                </div>
                <div className="text-xs text-gray-500">
                  {primeiro.unidadeSimbolo || ""} · {movimentacoes.length}{" "}
                  movimentação(ões)
                </div>
              </div>
              <div className="text-right text-sm">
                Total: <b>{total}</b>
                <div className="text-xs text-gray-500">
                  Saldo atual:{" "}
                  {movimentacoes[0].saldoAtual ??
                    movimentacoes[0].saldoPosterior}
                </div>
              </div>
            </button>
            {aberto && (
              <div className="overflow-x-auto bg-white px-4 pb-3">
                <table className="estoque-table table-historico-saidas w-full text-sm">
                  <thead>
                    <tr className="text-left text-xs text-gray-500">
                      <th className="p-2">Quantidade</th>
                      <th className="p-2">Saldo</th>
                      <th className="p-2">Data</th>
                      <th className="p-2">Observação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {movimentacoes.map((movimento) => (
                      <tr key={movimento.id} className="border-t">
                        <td className="p-2">
                          {movimento.quantidade} {movimento.unidadeSimbolo}
                        </td>
                        <td className="p-2">
                          {movimento.saldoAnterior} → {movimento.saldoPosterior}
                        </td>
                        <td className="p-2">
                          {movimento.criadoEm
                            ? new Date(movimento.criadoEm).toLocaleString(
                                "pt-BR",
                              )
                            : "—"}
                        </td>
                        <td className="p-2">{movimento.observacao || "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
